import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { BACKEND_URL } from "constants";
import { Spinner } from "react-bootstrap";

// 1. IMPORT the correct login action from your slice
import { userLogin } from "../../features/user/userSlice"; 

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [message, setMessage] = useState("Verifying your email...");
  const [status, setStatus] = useState("loading");
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setMessage("No verification token provided.");
      setStatus("error");
      return;
    }

    fetch(`${BACKEND_URL}/verify?token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setMessage("Your email has been verified successfully! Logging you in...");
          setStatus("success");

          if (!sessionStorage.getItem("leadTracked")) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: "targetcircle_lead",
            });
            sessionStorage.setItem("leadTracked", "1");
          }

          // --- AUTO LOGIN LOGIC ---
          if (data.user) {
            // 2. Dispatch the exact same action and structure used in Header.js
            dispatch(userLogin({ user: data.user }));
            
            // Redirect after 3 seconds
            setTimeout(() => {
              navigate("/"); 
            }, 3000);
          } else {
             setTimeout(() => navigate("/"), 3000); 
          }

        } else {
          setMessage(data.error || "Email verification failed.");
          
          if (data.error === "User is already verified") {
             setStatus("success");
             
             // If already verified but backend returned the user token, log them in anyway!
             if (data.user) {
                setMessage("Email already verified! Logging you in...");
                dispatch(userLogin({ user: data.user }));
             } else {
                setMessage("Email already verified! Redirecting...");
             }
             
             setTimeout(() => navigate("/"), 3000);
          } else {
            setStatus("error");
          }
        }
      })
      .catch((err) => {
        console.error("Verification Error:", err);
        setMessage("Something went wrong during verification.");
        setStatus("error");
      });
  }, [token, dispatch, navigate]);

  const renderIcon = () => {
    if (status === "loading") {
      return <Spinner animation="border" variant="primary" className="verify-email-spinner" />;
    }

    if (status === "success") {
      return <div className="verify-email-icon verify-email-icon-success">✓</div>;
    }

    return <div className="verify-email-icon verify-email-icon-error">✕</div>;
  };

  return (
    <div className="verify-email-page">
      <div className="verify-email-card bg-light rounded">
        <div className="verify-email-header">
          {renderIcon()}
          <h2 className="verify-email-title">Email Verification</h2>
          <p
            className={`verify-email-message ${
              status === "success"
                ? "verify-email-message-success"
                : status === "error"
                ? "verify-email-message-error"
                : ""
            }`}
          >
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;